import React, { useEffect, useRef, useState } from 'react';
import { Button, Link, Text, SwitchOption } from 'v3/components';

import { useSnackbar } from 'v3/components/Snackbar';
import { cooperplaceApi } from 'services/api';
import { Divider } from 'antd';
import { Row } from 'react-bootstrap';
import { DefaultLoadingBodyComponent } from 'v3/components/Card';
import { RequestLoad } from 'v3/pages/PreLoad/List/Modals/RequestLoad';

import Pagination from 'v3/components/DataTable/Pagination';
import { useModal } from 'hooks';
import moment from 'moment';
import RefuseLoadModal from './RefuseLoadModal';

import { useFleetManagement } from '../../shared';

import {
  DestinationContainer,
  ButtonContainer,
  LoadsTable,
  LoadsTableActions,
  LoadsTableCell,
  LoadsTableGrid,
  LoadsTableScroll,
} from './styles';

function formatDestionationTime(startSchedule, scheduledTime) {
  const start = moment(startSchedule).format('DD/MM/YYYY HH:mm');
  const end = moment(scheduledTime).format('DD/MM/YYYY HH:mm');
  return `${start} até ${end}`;
}

function CargSuggestions() {
  const {
    selected,
    suggestionData,
    setSuggestionData,
    loadSuggestionByVehicles,
    setLoadSuggestionByVehicle,
    loadSuggestionType,
    setLoadSuggestionType,
    setValidExistImplement,
    validExistImplement,
    setSwitchTrackerSuggestion,
    switchTrackerSuggestion,
    suggestionAdvencedFilters
  } = useFleetManagement();

  const [fetchOptions, setFetchOptions] = useState({
    page: 1,
    perPage: 5,
    total: 0,
    lastPage: 0,
  });
  const requestPreLoadModal = useModal();

  const [loadSuggestionTypeByVehicle, setLoadSuggestionTypeByVehicle] = useState(null);
  const [radiuSize, setRadiusSize] = useState(null);

  const [isFetching, setIsFetching] = useState(false);
  const [registerSelected, setRegisterSelected] = useState(null);
  const snackbar = useSnackbar();
  const paginationRef = useRef(null);
  const refuseLoadModal = useModal();

  const [requestPreLoad, setRequestPreLoad] = useState({ loadId: null });

  const Switch = () => {
    return (
      <SwitchOption
        inactiveText={'Pré Carga'}
        activeText={'Carga'}
        className="mt-1"
        style={{ marginBottom: -15 }}
        activeColor={'#494950'}
        inactiveColor={'#494950'}
        value={!switchTrackerSuggestion}
        onClick={() => {
          setSwitchTrackerSuggestion(old => !old);
        }}
      />
    )
  }

  const fetchData = async (select, page = 1) => {
    setIsFetching(true);
    try {

      const {
        data: { data: loadSuggestions, meta, typeSuggestions, radiusSize, errorImplement },
      } = await cooperplaceApi.get(
        `fleet/management/loadSugestion/${select.id}`,
        {
          params: {
            ...suggestionAdvencedFilters,
            ...fetchOptions,
            page,
            isPreLoad: switchTrackerSuggestion
          },
        }
      );

      setFetchOptions({
        page: meta.current_page,
        perPage: meta.per_page,
        total: meta.total,
        lastPage: meta.last_page,
      });
      setRadiusSize(radiusSize);
      setLoadSuggestionType(typeSuggestions);
      setSuggestionData({ data: loadSuggestions, meta });
      setLoadSuggestionByVehicle(false);
      setValidExistImplement(errorImplement);
    } catch (error) {
      setSuggestionData({ data: [] });
      snackbar.show(
        <Text>{error?.response?.data?.error || 'Erro ao trazer sugestões de cargas'}</Text>,
        {
          type: 'error',
        },
      );
    } finally {
      setIsFetching(false);
    }
  };

  const fetchVehiclesSuggested = async (select, page = 1) => {
    setIsFetching(true);
    try {

      const {
        data: { data: suggestionData, meta, typeSuggestions },
      } = await cooperplaceApi.get(
        `fleet/management/loadSuggestion-by-vehicle/${select.id}`,
        {
          params: {
            ...suggestionAdvencedFilters,
            ...fetchOptions,
            page,
            isPreLoad: switchTrackerSuggestion
          },
        }
      );
      setFetchOptions({
        page: meta.current_page,
        perPage: meta.per_page,
        total: meta.total,
        lastPage: meta.last_page,
      });
      setLoadSuggestionTypeByVehicle(typeSuggestions);
      setLoadSuggestionByVehicle(true);
      setSuggestionData({ data: suggestionData, meta });
    } catch (error) {
      setSuggestionData({ data: [] });
      snackbar.show(
        <Text>{error?.response?.data?.error || 'Erro ao trazer sugestões de cargas'}</Text>,
        {
          type: 'error',
        },
      );
    } finally {
      setIsFetching(false);
    }
  };

  const onPageChanged = async (page) => {
    if (loadSuggestionByVehicles) {
      await fetchVehiclesSuggested(selected, page);
    } else {
      await fetchData(selected, page);
    }
  };

  const handleRefuseLoad = (regSelected) => {
    setRegisterSelected(regSelected);
    refuseLoadModal.open();
  };

  useEffect(() => {
    if (selected?.id) {
      if (loadSuggestionByVehicles) {
        fetchVehiclesSuggested(selected);
      } else {
        fetchData(selected);
      }
    }
  }, [selected, switchTrackerSuggestion, suggestionAdvencedFilters]);

  const formatAddress = (formattedAddress, formatted) => {
    if (
      formattedAddress === null ||
      (typeof formattedAddress === 'string' && formattedAddress?.length === 0)
    ) {
      return formatted;
    }
    return formattedAddress;
  };

  const attendedLoad = (data, id, preLoad) => {
    if (preLoad && (!data || !data.isAttended)) {
      setRequestPreLoad({ loadId: id });
      requestPreLoadModal.open();
    } else {
      window.open(`/cargas/${id}`, '_blank');
    }
  };

  const Infos = ({ text }) => {
    return (
      <>
        <Row>
          <Text type='regular' weight={600}>
            {text}
          </Text>
        </Row>
        <Divider />
      </>
    )
  }

  const SuggestionInfos = ({ loadSuggestionType }) => {
    const externaLCooperplace = 'TRAVEL_EXTERNAL_AND_COOPERPLACE';
    const vehiclePosition = 'VEHICLE_POSITION';
    const travelExternal = 'TRAVEL_EXTERNAL';
    const vehicleType = 'VEHICLE_TYPE';

    return (
      !isFetching ? (
        loadSuggestionType === externaLCooperplace ? (
          <Infos text={'Cargas disponíveis com base no último destino da viagem cooperplace ou externa.'} />
        ) : loadSuggestionType === travelExternal ? (
          <Infos text={'Cargas disponíveis com base no último destino da viagem externa.'} />
        ) : loadSuggestionType === vehiclePosition ? (
          <Infos text={'Cargas disponíveis com base na posição atual do veículo.'} />
        ) : loadSuggestionTypeByVehicle === vehicleType ? (
          <Infos text={'Cargas disponíveis com base apenas no veículo e implemento.'} />
        ) : null
      ) : null
    )
  };

  const LoadsList = ({ suggestionData }) => {
    return (
      <>
        <div className="mt-2">
          {suggestionData?.data?.map(
            ({
              id,
              taker,
              loadOrigins,
              loadDestinations,
              product,
              takerValue,
              preTravel,
              preLoad,
            }) => (
              <React.Fragment key={id}>
                <LoadsTableGrid>
                  <LoadsTableCell>
                    <Link to={`/cargas/${id}`}>{id}</Link>
                  </LoadsTableCell>
                  <LoadsTableCell>
                    <Text type="label" weight={500} color="dark">
                      {taker?.label}
                    </Text>
                  </LoadsTableCell>
                  <LoadsTableCell>
                    <Text type="label" weight={500} color="dark">
                      {formatAddress(loadOrigins[0].formattedAddress, loadOrigins[0].formatted)}
                      <Text type="label" weight={500} color="dark" className="d-block mt-1">
                        <b>
                          {formatDestionationTime(
                            loadOrigins[0].startSchedule,
                            loadOrigins[0].scheduledTime,
                          )}
                        </b>
                      </Text>
                    </Text>
                  </LoadsTableCell>
                  <LoadsTableCell>
                    <DestinationContainer>
                      {loadDestinations.map(
                        (
                          {
                            formattedAddress,
                            scheduledTime,
                            startSchedule,
                            id: destinationId,
                            formatted,
                          },
                          index,
                          arr,
                        ) => (
                          <React.Fragment key={destinationId}>
                            <Text type="label" weight={500} color="dark">
                              {formatAddress(formattedAddress, formatted)}
                            </Text>
                            <Text type="label" weight={500} color="dark" className="d-block mt-1">
                              <b>{formatDestionationTime(startSchedule, scheduledTime)}</b>
                            </Text>
                            {arr.length - 1 !== index && <Divider />}
                          </React.Fragment>
                        ),
                      )}
                    </DestinationContainer>
                  </LoadsTableCell>
                  <LoadsTableCell>
                    <Text type="label" weight={500} color="dark">
                      {`${product?.name || 'Sem nome'} - ${product?.ncm || 'Sem NCM'}`}
                    </Text>
                  </LoadsTableCell>
                  <LoadsTableCell>
                    <Text type="label" weight={500} color="dark">
                      {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      }).format(takerValue)}
                    </Text>
                  </LoadsTableCell>
                  <LoadsTableCell>
                    <LoadsTableActions>
                      <Button
                        variant="success"
                        onClick={() => attendedLoad(preTravel, id, preLoad)}
                      >
                        Atender
                      </Button>
                      <Button
                        variant="error"
                        onClick={() => handleRefuseLoad(id)}
                      >
                        Recusar
                      </Button>
                    </LoadsTableActions>
                  </LoadsTableCell>
                </LoadsTableGrid>
                <Divider />
              </React.Fragment>
            ),
          )}
        </div>
        <div className="d-flex align-items-center justify-content-between">
          <Text type="label" color="gray">
            Exibindo {suggestionData.data?.length} de {fetchOptions.total} registros
          </Text>
          <div>
            <Pagination
              currentPage={fetchOptions.page}
              pages={fetchOptions.lastPage}
              onPageChanged={onPageChanged}
              ref={paginationRef}
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Switch />
      <Divider />
      <SuggestionInfos loadSuggestionType={loadSuggestionType} />
      <RefuseLoadModal
        selected={registerSelected}
        setSelected={setRegisterSelected}
        modalHook={refuseLoadModal}
        vehicleManagementId={selected?.id}
        refetch={() => fetchData(selected)}
      />
      <RequestLoad
        loadId={requestPreLoad.loadId}
        show={requestPreLoadModal.isOpen}
        onClose={() => {
          requestPreLoadModal.close();
          setRequestPreLoad({ loadId: null });
        }}
      />
      <LoadsTableScroll>
        <LoadsTable>
          <LoadsTableGrid>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Carga
              </Text>
            </LoadsTableCell>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Cliente
              </Text>
            </LoadsTableCell>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Origem
              </Text>
            </LoadsTableCell>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Destinos
              </Text>
            </LoadsTableCell>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Produto
              </Text>
            </LoadsTableCell>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Base de frete(Tomador)
              </Text>
            </LoadsTableCell>
            <LoadsTableCell>
              <Text type="label" weight={500} color="dark">
                Ação
              </Text>
            </LoadsTableCell>
          </LoadsTableGrid>
          {isFetching ? (
            <DefaultLoadingBodyComponent />
          ) : suggestionData.data?.length > 0 ? (
            <LoadsList suggestionData={suggestionData} />
          ) : validExistImplement ? (
            <ButtonContainer>
              <Text type="body" weight={600} color="dark">
                O veículo é do tipo cavalo mecânico e não possui implemento cadastrado.
              </Text>
              <Text type="body" weight={600} color="dark">
                Por favor, cadastre o implemento para que as cargas disponíveis possam ser
                visualizadas.
              </Text>
            </ButtonContainer>
          ) : !loadSuggestionByVehicles ? (
            <ButtonContainer>
              <Text type="body" weight={600} color="dark">
                Não há cargas no raio de {radiuSize}KM para a disponibilidade do veiculo
              </Text>

              <Button onClick={() => fetchVehiclesSuggested(selected)}>Exibir todas as cargas</Button>
            </ButtonContainer>
          ) : (
            <ButtonContainer>
              <Text weight={600} color="dark">
                Atualmente, não há cargas disponíveis para este veículo.
              </Text>
            </ButtonContainer>
          )}
        </LoadsTable>
      </LoadsTableScroll>
    </>
  );
}

export default CargSuggestions;
